module.exports = __webpack_public_path__ + "img/RENAULT- logo-100x130.9810f3e9.png";